﻿import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class ForceCancelClaimRequested {
    constructor(public workItemInfo: WorkItemInfo, public completionAction: () => void) {}

    static eventName() { return 'WorkTray.ForceCancelClaimRequested'; }

    eventName = ForceCancelClaimRequested.eventName;
}